/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { errorWithLevelWarning } from '../../error/error-with-level';
import { fetchWithTimeout } from '../../fetch/fetch';

/**
 * @import { ValueOf } from '../../../util.type'
 * @import { Warning } from '../../error/error-with-level'
 * @import { JSONValue } from '../../json'
 * @import { ServerDeviceId } from '../../session/session-attrs'
 */

/**
 * Komunikátor front z Ki-Wi Serveru.
 */
export default class CommunicatorQueue {
  /**
   * Získá surový JSON objekt z fronty.
   * @param {ServerDeviceId} serverDeviceId
   * @param {string} queueId
   * @returns {Promise<JSONValue | undefined>} JSON nebo `undefined`, pokud je fronta prázdná.
   * @throws {Warning}
   */
  static async fetch(serverDeviceId, queueId) {
    const { deviceId, serverUrl } = serverDeviceId;
    const response = await fetchWithTimeout(
      `${serverUrl}/api/device/${deviceId}/queue/${queueId}`,
      { method: 'POST' }
    )
      // Snížení priority logování pro chyby síťového spojení.
      .catch((error) => {
        throw errorWithLevelWarning(error);
      });

    // 404 značí prázdnou frontu.
    if (response.status === 404) {
      return;
    }

    // Snížení priority logování pro chyby ze serveru.
    if (!response.ok) {
      throw errorWithLevelWarning(
        new RangeError(`Invalid HTTP status "${response.status}".`)
      );
    }

    return /** @type {JSONValue} */ (await response.json());
  }
}

/**
 * Výčet známých identifikátorů front.
 * @enum {ValueOf<typeof QueueIdEnum>}
 * @readonly
 */
export const QueueIdEnum = Object.freeze({
  COMMAND: 'action'
});
